import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Settings,
  LogOut,
  Store,
  FolderOpen,
  Package,
  Beaker,
  BarChart2,
} from "lucide-react";
import { Button } from "./ui/button";
import { cn } from "../lib/utils";

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  cn(
    "flex items-center gap-3 px-6 py-3 text-sm font-light tracking-wide transition-colors duration-300",
    isActive
      ? "bg-primary-100 dark:bg-primary-800 text-primary-900 dark:text-white"
      : "text-primary-600 dark:text-primary-400 hover:bg-primary-50 dark:hover:bg-primary-900 hover:text-primary-900 dark:hover:text-white"
  );

export interface AdminSidebarContentProps {
  onNavigate?: () => void;
  onLogout: () => void;
}

export function AdminSidebarContent({ onNavigate, onLogout }: AdminSidebarContentProps) {
  return (
    <>
      <div className="px-6 py-8 border-b border-primary-200 dark:border-primary-800">
        <p className="text-xs font-light tracking-widest uppercase text-primary-500 dark:text-primary-500">
          WhatsApp Store
        </p>
        <p className="text-lg font-light tracking-tight text-primary-900 dark:text-white mt-1">
          Admin
        </p>
      </div>

      <nav className="flex-1 py-6" aria-label="Administração">
        <NavLink to="/dashboard" className={navLinkClass} onClick={onNavigate}>
          <LayoutDashboard className="h-4 w-4" />
          Dashboard
        </NavLink>
        <NavLink to="/store/settings" className={navLinkClass} onClick={onNavigate}>
          <Store className="h-4 w-4" />
          Minha loja
        </NavLink>
        <NavLink to="/categories" className={navLinkClass} onClick={onNavigate}>
          <FolderOpen className="h-4 w-4" />
          Categorias
        </NavLink>
        <NavLink to="/products" className={navLinkClass} onClick={onNavigate}>
          <Package className="h-4 w-4" />
          Produtos
        </NavLink>
        <NavLink to="/insumos" className={navLinkClass} onClick={onNavigate}>
          <Beaker className="h-4 w-4" />
          Insumos
        </NavLink>
        <NavLink to="/analytics" className={navLinkClass} onClick={onNavigate}>
          <BarChart2 className="h-4 w-4" />
          Análises
        </NavLink>
        <NavLink to="/settings" className={navLinkClass} onClick={onNavigate}>
          <Settings className="h-4 w-4" />
          Configurações
        </NavLink>
      </nav>

      <div className="p-4 border-t border-primary-200 dark:border-primary-800">
        <Button
          type="button"
          variant="ghost"
          className="w-full justify-start gap-3"
          onClick={onLogout}
        >
          <LogOut className="h-4 w-4" />
          Sair
        </Button>
      </div>
    </>
  );
}
